<div class="state" [ngStyle]="{background: getStateColors(), color: getStateTextColors()}">
<!--  <app-loader *ngIf="loading"></app-loader>-->
  <ng-content class="state__text body4"></ng-content>
  <img
    *ngIf="!loading && isIcon"
    [src]="getStateIcon()"
    class="state__icon"
    [attr.alt]="'alt.stateIcon' | translate"
  />
</div>
